export default {
      id: "ic-nav-check-usage",
      viewBox: "0 0 26 26",
      url: "../dist/images/" + "sprite.svg#ic-nav-check-usage",
      toString: function () {
        return this.url;
      }
    }